<template>
    <div class="principal">
        <NavBar :usarAberto="true" :usarHistorico="false" :usarVoltar="false" :usarDeslogar="false" :usarGerenciar="false"
            :usarInternacao="false" :usarRelatorio="false" :usarFiltroSetor="false" :usarFiltroTpChamado="false"
            :usarFiltroPosicao="false" :principal="false" :formatarDataInicioMes="formatarDataInicioMes">
        </NavBar>
        <div class="scrollspy-example w-100 d-flex align-self-center flex-column mb-2" style="min-height: 84vh;">
            <div class="w-100 d-flex align-self-center mt-3 flex-column tamanho">
                <label class="form-label" for="">Código
                    <div class="input-group">
                        <input class="form-control" type="number" name="" id="" v-model="state.idInternacao"
                            @keyup.enter="onDecode(state.idInternacao)">
                        <!-- @input="lerOutraVez()" -->
                        <button class="btn btn-secondary" @click="onDecode(state.idInternacao)">Pesquisar</button>
                    </div>
                </label>
                <QrcodeStream v-if="state.camera == true" @init="onInit" @decode="onDecode" id="camera" class="mb-2">
                    <!--  -->
                    <div style="color: red;" class="frame"></div>
                </QrcodeStream>
                <div class="card" v-show="state.camera == false">
                    <div class="card-body">
                        <table class="table">
                            <thead>
                                <tr style="text-align: center;">
                                    <h3 class="px-0 pt-0">
                                        Dados gerais da internação
                                    </h3>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(chave, index) in Object.keys(state.internacao)" :key="index">
                                    <span class="fw-bold" v-if="state.internacao[chave]">
                                        {{ state.lstCampos[index] }}
                                        <span v-if="state.internacao[chave]" class="fw-lighter">
                                            - {{ retornaDadoLinha(state.internacao[chave]) }}
                                        </span>
                                    </span>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="">
                    <button class="btn btn-secondary w-100 my-2" @click="lerOutraVez" v-show="state.camera == false">
                        Ler o QR Code outra vez
                    </button>
                    <div class="d-flex justify-content-between w-100">
                        <div class="fotos">
                            <button class="btn btn-success me-1" v-if="state.internacao.id > 0" @click="abrirModalFoto">
                                Nova Foto
                            </button>
                            <button class="btn btn-success novoVideo" v-if="state.internacao.id > 0"
                                @click="abrirModalVideo">
                                Novo Vídeo
                            </button>
                        </div>
                        <button class="btn btn-primary" v-if="state.internacao.id > 0" @click="gravarFotosFinalizar">
                            Finalizar
                        </button>
                    </div>
                </div>
                <canvas ref="canvasElement" style="display: none;"></canvas>
            </div>
            <div id="" class="carousel slide mt-2" style="min-height: 30vh;"
                v-if="state.lstFotos.length > 0 || state.lstVideos.length > 0">
                <div class="carousel-inner">
                    <div :id="`img${index}`" class="carousel-item flex-column align-items-center"
                        v-for="(img, index) in state.lstFotos" :key="index" :class="{ 'active': index == 0 }">
                        <img :src="retornaImagem(img?.img)" alt="Captured" style="min-height: 285px; max-height: 285px;" />
                        <!-- <img class="position-absolute cursor-pointer" style="top: 4%;right: 36%;"
                            src="../assets/icons/x-lg.svg" alt="" @click="filtrarFotos(img)"> -->
                    </div>
                    <div :id="`img${index + state.lstFotos.length}`" class="carousel-item flex-column align-items-center"
                        v-for="(img, index) in state.lstVideos" :key="index" :class="{ 'active': index == 0 }">
                        <video :src="desconverterVideoBase64(img.video)" controls
                            style="min-height: 285px; max-height: 285px;" />
                        <!-- <img class="position-absolute cursor-pointer" style="top: 4%;right: 36%;"
                            src="../assets/icons/x-lg.svg" alt="" @click="filtrarVideos(img)"> -->
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev"
                    v-show="(state.lstFotos.length >= 2 || state.lstVideos.length >= 2) || (state.lstFotos.length > 0 && state.lstVideos.length > 0)"
                    style="left: 10%; " @click="trocarFotoCarrossel('prev')">
                    <span class="carousel-control-prev-icon border-1 bg-black" aria-hidden="true"></span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next"
                    v-show="(state.lstFotos.length >= 2 || state.lstVideos.length >= 2) || (state.lstFotos.length > 0 && state.lstVideos.length > 0)"
                    style="right: 10%; " @click="trocarFotoCarrossel('next')">
                    <span class="carousel-control-next-icon border-1 bg-black" aria-hidden="true"></span>
                </button>
            </div>
        </div>
    </div>
    <ModalEditar :mostrar="state.novaFoto" :modalLargo="false" :tamanhoModal="55">
        <template v-slot:header>
            Capturar Foto
        </template>
        <template v-slot:corpo>
            <div class="row p-2 mb-2">
                <select class="form-select" name="" id="" v-model="state.idTipoFoto">
                    <option value="0" disabled>Tipo da Foto</option>
                    <option v-for="t in state.lstTipoFoto" :key="t" :value="t.id">
                        {{ t.descricao }}
                    </option>
                </select>
            </div>
            <div class="w-100 d-flex justify-content-center align-items-center mb-2">
                <video class="form-control" ref="videoElement" autoplay></video>
            </div>
        </template>
        <template v-slot:rodape>
            <button class="btn btn-primary" @click="salvarFoto">Salvar</button>
            <button class="btn btn-secondary" @click="fecharModalFoto">Fechar</button>
        </template>
    </ModalEditar>
    <ModalEditar :mostrar="state.novoVideo" :modalLargo="false" :tamanhoModal="55">
        <template v-slot:header>
            Capturar Video
        </template>
        <template v-slot:corpo>
            <div class="row p-2 mb-2">
                <select class="form-select" name="" id="" v-model="state.idTipoFoto">
                    <option value="0" disabled>Tipo do Video</option>
                    <option v-for="t in state.lstTipoFoto" :key="t" :value="t.id">
                        {{ t.descricao }}
                    </option>
                </select>
            </div>
            <p>{{ state.segundos }} segundos / {{ state.tempoMaximo }} segundos</p>
            <div class="w-100 d-flex justify-content-center align-items-center mb-2">
                <video class="form-control video" ref="videoElementVideo" autoplay
                    v-if="state.isRecording || state.videoUrl.trim().length < 1"></video>
                <video class="form-control video" ref="videoElementVideoGravado" :src="state.videoUrl" name="video"
                    v-if="!state.isRecording && state.videoUrl" controls></video>
            </div>
            <button class="btn btn-primary w-100" @click="startRecording" v-if="!state.isRecording">Iniciar
                Gravação</button>
            <button class="btn btn-primary w-100" @click="stopRecording" v-else>Parar Gravação</button>
        </template>
        <template v-slot:rodape>
            <button class="btn btn-primary" @click="salvarVideo">Salvar</button>
            <button class="btn btn-secondary" @click="fecharModalVideo">Fechar</button>
        </template>
    </ModalEditar>
    <ModalEditar :mostrar="state.finalizarEnvioFotos" :modalLargo="false" :tamanhoModal="55">
        <template v-slot:header>
            Finalizar
        </template>
        <template v-slot:corpo>
            <div class="row p-2 mb-2">
                <select class="form-select" name="" id="" v-model="state.internacaoArq.idTipoAtendimento"
                    @change="filtrarSubTipos">
                    <option value="0" disabled>Tipo de atendimento</option>
                    <option v-for="t in state.lstTipoAtendimento" :key="t" :value="t.id">
                        {{ t.descricao }}
                    </option>
                </select>
            </div>
            <div class="row p-2 mb-2">
                <select class="form-select" name="" id="" v-model="state.internacaoArq.idSubTipoAtendimento"
                    :disabled="!(state.internacaoArq.idTipoAtendimento > 0)">
                    <option value="0" disabled>Sub-tipo de atendimento</option>
                    <option v-for="t in state.lstSubTipoAtendimentoFiltrados" :key="t" :value="t.id">
                        {{ t.descricao }}
                    </option>
                </select>
            </div>
            <div class="w-100 mt-2">
                <textarea name="" id="" class="form-control" v-model="state.internacaoArq.obs"
                    placeholder="Observação (opcional)"></textarea>
            </div>
        </template>
        <template v-slot:rodape>
            <button class="btn btn-primary" @click="GravarEnvioFotos">Gravar</button>
            <button class="btn btn-secondary" @click="CancelarEnvioFotos">Fechar</button>
        </template>
    </ModalEditar>
    <ModalConfirmaAgape :visible="state.fotoSalva" title="Sucesso" text="Enviado com sucesso" :aviso="true"
        @modalResult="modalResultFotoSalva">
    </ModalConfirmaAgape>
    <ModalConfirmaAgape :visible="state.fotoNaoSalva" title="Erro"
        text="A foto não foi salva. Verifique se está conectado a internet ou aguarde um pouco e tente novamente"
        :aviso="true" @modalResult="modalResultFotoNaoSalva">
    </ModalConfirmaAgape>
    <ModalConfirmaAgape v-if="state.erro" :visible="state.erro" :title="state.tipoErro" :text="state.textErro" :aviso="true"
        @modalResult="modalResultErro">
    </ModalConfirmaAgape>
</template>

<script setup>
import NavBar from '@/components/NavBar.vue';
import { reactive, defineProps, ref, onMounted } from 'vue';
import { QrcodeStream } from "vue3-qrcode-reader";
import api from '@/api/api';
import moment from "moment";
import Internacao from '@/model/Internacao';
import InternacaoArq from '@/model/InternacaoArq';
import { getBase64, getStringBase64, setStringBase64 } from '@/utils/utils';
import ModalEditar from '@/components/ModalEditar.vue';
import ModalConfirmaAgape from '@/components/ModalConfirmaAgape.vue';

const props = defineProps(['formatarDataInicioMes']);

const state = reactive({
    lstCampos: Array('Código', 'Código do Paciente', "Nome do Paciente", "Data da Internação", "Hora da Internação"),
    lstFotos: [],
    lstVideos: [],
    lstTipoAtendimento: [],
    lstSubTipoAtendimento: [],
    lstSubTipoAtendimentoFiltrados: [],
    lstTipoFoto: [],

    internacao: {},
    internacaoArq: {
        idInternacao: Number(0),
        idTipoAtendimento: Number(0),
        idSubTipoAtendimento: Number(0),
        dtLanc: new Date(),
        hrLanc: String(),
        obs: ""
    },
    internacaoArqItem: {
        idTipoFoto: Number(0),
    },

    idInternacao: Number(0),
    idTipoFoto: Number(),
    segundos: Number(),
    tempoMaximo: Number(45),

    textErro: String(),
    tipoErro: String(),

    camera: Boolean(true),
    novaFoto: Boolean(),
    novoVideo: Boolean(),
    fotoSalva: Boolean(),
    fotoNaoSalva: Boolean(),
    erro: Boolean(),
    finalizarEnvioFotos: Boolean(),

    isRecording: false,
    mediaStream: MediaStream,
    mediaRecorder: MediaRecorder,
    videoChunks: [],
    videoUrl: '',
    videoBase64: "",

    selectedVideo: null,
    videoData: null,

    intervalo: {},
});

const videoElement = ref(null);
const videoElementVideo = ref(null);
const videoElementVideoGravado = ref(null);
const canvasElement = ref(null);

async function onInit(promise) {
    try {
        const { capabilities } = await promise;
    } catch (error) {
        if (error.name === 'NotAllowedError') {
            state.textErro = "Usuário negou permissão à camera";
        } else if (error.name === 'NotFoundError') {
            state.textErro = "Não possui um dispositivo válido instalado";
        } else if (error.name === 'NotSupportedError') {
            state.textErro = "A página não está sobre protocolo HTTPS";
        } else if (error.name === 'NotReadableError') {
            state.textErro = "Talvez a camera já esteja em uso";
        } else if (error.name === 'OverconstrainedError') {
            state.textErro = "Não foi possivel encontrar a camera selecionada";
        } else if (error.name === 'StreamApiNotSupportedError') {
            state.textErro = "O navegador parece não ter essa funcionalidade";
        } else if (error.name === 'InsecureContextError') {
            state.textErro = "Sua conexão não é segura";
        }
        state.tipoErro = "Erro";
        state.erro = true;
    }
}

function lerOutraVez() {
    state.internacao = {};
    // onInit();
    state.camera = true;
}

function limparObjeto() {
    state.internacao = {};
    state.internacaoArq = {
        idTipoAtendimento: Number(0),
        idSubTipoAtendimento: Number(0),
        obs: ""
    };
    state.internacaoArqItem = {
        idTipoFoto: Number(0),
    };
    state.lstFotos = [];
}

async function onDecode(decodedString) {
    console.log(decodedString);
    if (decodedString) {
        await api.InternacaoListarPorId(decodedString)
            .then(resp => {
                if (resp) {
                    state.idInternacao = resp.id;
                    state.internacaoArq.idInternacao = resp.id;
                    Object.keys(resp).forEach((o) => {
                        state.internacao[o] = resp[o];
                    });
                    state.camera = false;
                } else {
                    state.erro = true;
                    state.textErro = `Não foi encontrada a internação de código ${decodedString}. O paciente pode ter recebido alta ou a internação pode ser inexistente.`;
                    state.tipoErro = "Aviso";
                }
            });
    } else {
        state.erro = true;
        state.textErro = "Digite ou escaneie um número válido";
        state.tipoErro = "Aviso";
    }
}

function retornaDadoLinha(pDado) {
    if (String(pDado).includes('T00:00:00'))
        return moment(pDado).format('DD/MM/YYYY');

    if (typeof pDado === 'object' && pDado?.descricao)
        return pDado?.descricao;

    if (typeof pDado === 'object' && pDado?.nome)
        return pDado?.nome;

    if (typeof pDado === 'object')
        return "NÃO INFORMADO";

    if (String(pDado).includes(':') && String(pDado).includes('.')) {
        let horaFormatada = "";
        for (let i = 0; i < String(pDado).indexOf('.'); i++) {
            horaFormatada += pDado[i];
        }
        return horaFormatada;
    }
    if (typeof pDado !== 'string' || !pDado.includes('T00:00:00')) {
        return pDado;
    }
}

function abrirModalFoto() {
    state.novaFoto = true;
    setTimeout(() => {
        setupCamera();
    }, 200);
}

function fecharModalFoto() {
    state.novaFoto = false;
}

async function salvarFoto() {
    // if (state.internacaoArq.idTipoAtendimento > 0 && state.internacaoArq.idSubTipoAtendimento > 0) {
    if (state.idTipoFoto > 0) {
        capturePhoto();

        state.internacaoArq.idInternacao = state.internacao.id;
        state.internacaoArq.item = 0;
        state.internacaoArq.dtLanc = new Date();
        state.internacaoArq.hrLanc = `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`;

        let sqlItemInternacaoArq = "";

        sqlItemInternacaoArq += `SELECT COALESCE(MAX(ITEM),0) FROM INTERNACAO_ARQ WHERE ID_INTERNACAO = ${state.internacao.id}`;

        await api.listarSqlPortal(sqlItemInternacaoArq)
            .then(resp => {
                state.internacaoArq.item = resp[0] + 1;
            });

        fecharModalFoto();
    } else {
        state.textErro += "Selecione o Tipo ";
        state.erro = true;
        state.textErro += "da foto";
    }
    // } else {
    //     if (!(state.internacaoArq.idTipoAtendimento > 0))
    //         state.textErro += "Selecione o Tipo ";
    //     if (state.internacaoArq.idTipoAtendimento > 0 && !(state.internacaoArq.idSubTipoAtendimento > 0))
    //         state.textErro += "Selecione o Sub-Tipo ";
    //     if (!(state.internacaoArq.idTipoAtendimento) > 0 && !(state.internacaoArq.idSubTipoAtendimento > 0))
    //         state.textErro += "e o Sub-Tipo ";
    //     state.erro = true;
    //     state.textErro += "da foto";
    // }
}

function capturePhoto() {
    const video = videoElement.value;
    const canvas = canvasElement.value;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

    const photoUrl = canvas.toDataURL('image/png');

    state.lstFotos.push({
        'img': photoUrl,
        'idTipoFoto': state.idTipoFoto,
    });

    setTimeout(() => {
        let id = document.getElementsByClassName("active")[0].getAttribute("id");
        id = id.replace("img", "");
        document.getElementById(`img${Number(id)}`).classList.remove("active");
        document.getElementById(`img${state.lstFotos.length - 1}`).classList.add("active");
    }, 100);
}

async function setupCamera() {
    try {
        let stream;
        stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
        videoElement.value.srcObject = stream;
    } catch (error) {
        console.error('Erro ao acessar a câmera:', error);
    }
}

function modalResultFotoSalva() {
    state.fotoSalva = false;
}

function modalResultFotoNaoSalva() {
    state.fotoNaoSalva = false;
}

function trocarFotoCarrossel(pParam) {
    let id = document.getElementsByClassName("active")[0].getAttribute("id");
    id = id.replace("img", "");
    document.getElementById(`img${Number(id)}`).classList.remove("active");
    if (pParam == "prev") {
        if (document.getElementById(`img${Number(id) - 1}`) == null) {
            document.getElementById(`img${state.lstFotos.length + state.lstVideos.length - 1}`).classList.add("active");
        } else {
            document.getElementById(`img${Number(id) - 1}`).classList.add("active");
        }
    }
    if (pParam == "next") {
        if (document.getElementById(`img${Number(id) + 1}`) == null) {
            document.getElementById(`img${0}`).classList.add("active");
        } else {
            document.getElementById(`img${Number(id) + 1}`).classList.add("active");
        }
    }
}

function gravarFotosFinalizar() {
    state.finalizarEnvioFotos = true;
}

async function GravarEnvioFotos() {
    let dia = new Date();
    let hora = "", minuto = "", segundo = "";

    hora += (dia.getHours() <= 9) ? `0${dia.getHours()}` : `${dia.getHours()}`;
    minuto += (dia.getMinutes() <= 9) ? `0${dia.getMinutes()}` : `${dia.getMinutes()}`;
    segundo += (dia.getSeconds() <= 9) ? `0${dia.getSeconds()}` : `${dia.getSeconds()}`;
    state.internacaoArq.hrLanc = `${hora}:${minuto}:${segundo}`;
    state.internacaoArq.dtLanc = new Date();

    if (state.lstFotos.length > 0 || state.lstVideos.length > 0) {
        await api.InternacaoArqInserir(state.internacaoArq)
            .then(r => {
                console.log(r);
                if (r != "Ok") {
                    state.erro = true;
                }
            });
        let i = 0, j = 0;

        state.lstFotos.forEach(async (f, i) => {
            state.internacaoArqItem.idInternacao = state.internacao.id;
            state.internacaoArqItem.itemArq = state.internacaoArq.item;
            state.internacaoArqItem.item = i + 1;
            state.internacaoArqItem.arquivo = getStringBase64(f.img);
            state.internacaoArqItem.idTipoFoto = f.idTipoFoto;
            await api.InternacaoArqItemInserir(state.internacaoArqItem)
                .then(r => {
                    console.log(r);
                    if (r != "Ok") {
                        state.erro = true;
                    }
                    i++;
                });
        });

        state.lstVideos.forEach(async (v, i) => {
            state.internacaoArqItem.idInternacao = state.internacao.id;
            state.internacaoArqItem.itemArq = state.internacaoArq.item;
            state.internacaoArqItem.item = state.lstFotos.length + i + 1;
            state.internacaoArqItem.arquivo = "video" + v.video;
            state.internacaoArqItem.idTipoFoto = v.idTipoFoto;
            await api.InternacaoArqItemInserir(state.internacaoArqItem)
                .then(r => {
                    console.log(r);
                    if (r != "Ok") {
                        state.erro = true;
                    }
                    j++;
                });
        });
    }
    else {
        state.erro = true;
        state.textErro = `Deve ser gravada pelo menos uma mídia, seja foto ou vídeo`;
    }


    if (state.erro == false) {
        limparObjeto();
        state.idInternacao = Number();
        state.camera = true;
        state.fotoSalva = true;
        state.lstVideos = [];
        state.finalizarEnvioFotos = false;
        // } else {
        //     console.log(i);
        //     console.log(j);
        //     state.finalizarEnvioFotos = false;
        //     state.erro = true;
        //     state.textErro = `Ocorreu um erro, por favor refaça o login e tente novamente. Se persistirem os sintomas, o suporte deverá ser consultado`;
    }
}

function CancelarEnvioFotos() {
    state.finalizarEnvioFotos = false;
}

function retornaImagem(img) {
    return (img) ? (String(img).includes('base64')) ? img : setStringBase64(img) : "";
}

async function filtrarSubTipos() {
    await api.SubTipoAtendimentoListarPorIdTipoAtendimento(state.internacaoArq.idTipoAtendimento)
        .then(resp => {
            state.lstSubTipoAtendimentoFiltrados = resp;
        });
}

function modalResultErro() {
    state.erro = false;
    state.textErro = "";
}

async function startRecording() {
    let intervalo;
    // let tempoMaximo = false;
    try {
        state.mediaStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' }, audio: true });
        state.mediaRecorder = new MediaRecorder(state.mediaStream);

        state.mediaRecorder.ondataavailable = async (event) => {
            if (event.data.size > 0) {
                clearInterval(intervalo);
                state.videoChunks.push(event.data);
                const blob = new Blob(state.videoChunks, { type: 'video/webm' });
                const videoUrl = URL.createObjectURL(blob);
                state.videoUrl = videoUrl;
                await converterVideoBase64(event.data);
                state.segundos = 0;
                // if (tempoMaximo == true) {
                //     salvarVideo();
                // }
            }
        };

        state.mediaRecorder.onstart = (event) => {
            videoElementVideo.value.srcObject = state.mediaStream;
        };

        state.mediaRecorder.start();
        state.isRecording = true;
        intervalo = setInterval(async () => {
            state.segundos = state.segundos + 1;
            if (state.segundos == state.tempoMaximo) {
                await stopRecording();
                // tempoMaximo = true;
            }
        }, 1000);
    } catch (error) {
        console.error('Erro ao acessar a câmera:', error);
    }
}

async function converterVideoBase64(pVideo) {
    const reader = new FileReader();
    reader.onload = async () => {
        const base64String = btoa(
            new Uint8Array(reader.result)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
        );
        state.videoBase64 = base64String;
    };
    reader.readAsArrayBuffer(pVideo);
}

function desconverterVideoBase64(pVideo) {
    const byteCharacters = atob(pVideo);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'video/webm' });

    return URL.createObjectURL(blob);
}

function stopRecording() {
    if (state.mediaRecorder && state.isRecording) {
        state.mediaRecorder.stop();
        state.mediaStream.getTracks().forEach((track) => track.stop());
        state.isRecording = false;
        // state.intervalo = clearInterval();
        // clearInterval(state.intervalo);
    }
}

function abrirModalVideo() {
    state.novoVideo = true;
}

async function salvarVideo() {
    stopRecording();
    if (state.idTipoFoto > 0) {
        let sqlItemInternacaoArq = "";
        sqlItemInternacaoArq += `SELECT COALESCE(MAX(ITEM),0) FROM INTERNACAO_ARQ WHERE ID_INTERNACAO = ${state.internacao.id}`;
        await api.listarSqlPortal(sqlItemInternacaoArq)
            .then(resp => {
                state.internacaoArq.item = resp[0] + 1;
                state.lstVideos.push({ "video": state.videoBase64, "idTipoFoto": state.idTipoFoto });
                setTimeout(() => {
                    let id = document.getElementsByClassName("active")[0].getAttribute("id").replace("img", "");
                    document.getElementById(`img${Number(id)}`).classList.remove("active");
                    document.getElementById(`img${state.lstFotos.length + state.lstVideos.length - 1}`).classList.add("active");
                }, 100);
            });
        fecharModalVideo();
    } else {
        state.textErro += "Selecione o Tipo do Vídeo";
        state.erro = true;
    }
}

function fecharModalVideo() {
    state.isRecording = false;
    state.mediaStream = null;
    state.mediaRecorder = null;
    state.videoChunks = [];
    state.videoUrl = '';
    state.novoVideo = false;
}

function filtrarFotos(img) {
    state.lstFotos = state.lstFotos.filter(f => f.img != img.img);
    if (state.lstFotos.length > 0 || state.lstVideos.length > 0) {
        setTimeout(() => {
            document.getElementById("img0").classList.add("active");
        }, 50);
    }
}

function filtrarVideos(img) {
    state.lstVideos = state.lstVideos.filter(v => v.video != img.video);
    if (state.lstFotos.length > 0 || state.lstVideos.length > 0) {
        setTimeout(() => {
            document.getElementById("img0").classList.add("active");
        }, 50);
    }
}

onMounted(async () => {
    await api.TipoAtendimentoListar()
        .then(resp => {
            resp.forEach(r => {
                if (r.ativo) {
                    state.lstTipoAtendimento.push(r);
                }
            });
        });

    await api.SubTipoAtendimentoListar()
        .then(resp => {
            resp.forEach(r => {
                if (r.ativo) {
                    state.lstSubTipoAtendimento.push(r);
                }
            });
        });

    await api.TipoFotoListar()
        .then(resp => {
            resp.forEach(r => {
                if (r.ativo) {
                    state.lstTipoFoto.push(r);
                }
            });
        });
});

</script>

<style scoped>
.scrollspy-example {
    position: relative;
    /*height: 200px;*/
    margin-top: 0.5rem;
    overflow: auto;
}

.active {
    display: flex !important;
    justify-content: center;
}

.tamanho {
    min-height: 40vh;
    max-width: 50vw;
}

.video {
    max-width: 100%;
    max-height: 60vh;
    min-height: 60vh;
}

@media only screen and (max-width: 462px) {
    .novoVideo {
        margin-top: 0.25rem;
    }
}


@media only screen and (max-width: 466px) {
    .novoVideo {
        margin-right: 0.25rem;
    }
}

@media only screen and (max-width: 576px) {
    .tamanho {
        max-width: 80vw;
    }

    .video {
        min-width: 100vw;
        max-width: 100vw;
        min-height: 60vh;
        max-height: 60vh;
    }
}

@media only screen and (max-width: 600px) {
    .tamanho {
        max-width: 80vw;
    }
}

@media only screen and (max-width: 750px) {
    .tamanho {
        max-width: 65vw;
    }
}
</style>